import type { JSONContent } from "@tiptap/core";

export const extractImgUrlList = (json: JSONContent) => {
  const urlList: string[] = [];
  json?.content?.forEach((item) => {
    if (item.type === "editorImage") {
      urlList.push(item.attrs!.src);
    }
  });
  return urlList;
};

export const extractImgAndTxtList = (
  json: JSONContent
): { url: string; text?: string }[] => {
  const resultList: { url: string; text?: string }[] = [];
  let prevText = "";
  json?.content?.forEach((item) => {
    if (item.type === "editorImage") {
      resultList.push({ url: item.attrs!.src, text: prevText });
      prevText = "";
    } else if (item.type === "paragraph") {
      const textList = item.content
        ?.filter((item) => item.type === "text")
        .map((item) => item.text);
      if (textList) {
        prevText = textList[textList.length - 1] ?? "";
      }
    }
  });
  return resultList;
};

export const getWordCount = (json: JSONContent) => {
  let count = 0;
  // 递归
  const countWord = (json: JSONContent) => {
    json?.content?.forEach((item) => {
      if (item.type === "text") {
        count += item.text!.length;
      } else {
        countWord(item);
      }
    });
  };
  countWord(json);
  return count;
};

export const text2GameStory = (storyId: number, story: any[]) => {
  let list: StoryScene[] = [];
  let tmpImgSrc = "";
  for (const { type, attrs, content } of story) {
    if (type === "editorImage") tmpImgSrc = attrs.src;

    if (type === "paragraph" && content && content.length > 0) {
      const { text } = content[0];
      if (typeof text === "string" && text.trim())
        list.push({
          storyId: storyId!,
          text,
          imageMediaUrl: tmpImgSrc,
          order: 0,
        });
    }
  }
  list.reverse().forEach((v, i) => (v.order = i));
  return list;
};
export const text2GalGameStory = (
  storyNodeId: number,
  characterId: number,
  story: any[]
) => {
  let list: any = [];
  let tmpImgSrc = "";
  for (const { type, attrs, content } of story) {
    if (type === "editorImage") tmpImgSrc = attrs.src;

    if (type === "paragraph" && content && content.length > 0) {
      const { text } = content[0];
      if (typeof text === "string" && text.trim())
        list.push({
          storyNodeId,
          characterId,
          text,
          sceneMediaUrl: tmpImgSrc,
          order: 0,
        });
    }
  }
  list.reverse().forEach((v: any, i: number) => (v.order = i));
  return list;
};
/**
 * 处理html内容，为所有图片src添加x-oss-process=style/preview查询参数
 *
 * @param html - 需要处理的html字符串
 * @returns 处理后的html字符串
 */
export const processHtmlImageSrc = (html: string): string => {
  if (!html) return html;

  const imgRegex = /<img[^>]+src\s*=\s*["']([^"']+)["'][^>]*>/gi;

  return html.replace(imgRegex, (match, src) => {
    const processedSrc =
      src + (src.includes("?") ? "&" : "?") + "x-oss-process=style/preview";
    return match.replace(src, processedSrc);
  });
};
